export const getVoiceEnginesUrl = () => '/agency/available_voice_engines';

export const getVoiceEngineUrl = (id: number) => `/agency/available_voice_engines/${id}`;

export const getBusinessVoiceEnginesUrl = (availableVoiceEngineId: number) =>
  `/agency/available_voice_engines/${availableVoiceEngineId}/business_voice_engines`;
